import React from 'react';

import { styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';
import { getConditionalObject } from 'utils/data';

import {
  statusIconColorPairs,
  StatusIconComponents,
  StatusIconComponentsOutlines,
} from './StatusIcon.constants';

const StatusCountTypeIcon = styled(Typography)(({ size, status }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 500,
  userSelect: 'none',
  borderRadius: '50%',
  ...getConditionalObject(size, {
    width: `${size}px`,
    height: `${size}px`,
  }),
  ...getConditionalObject(status, {
    backgroundColor: statusIconColorPairs[status]?.backgroundColor,
    color: statusIconColorPairs[status]?.color,
  }),
}));

const StatusIcon = ({
  status,
  count = null,
  size = 20,
  isCountTypeIcon = false,
  isOutlined = false,
}) => {
  if (isCountTypeIcon && count !== 0) {
    if (count === null) {
      return <StatusCountTypeIcon size={size}>-</StatusCountTypeIcon>;
    }

    return (
      <StatusCountTypeIcon size={size} status={status}>
        {count}
      </StatusCountTypeIcon>
    );
  }

  const StatusIconComponent = isOutlined
    ? StatusIconComponentsOutlines[status]
    : StatusIconComponents[status];

  return StatusIconComponent && <StatusIconComponent height={size} width={size} />;
};

StatusIcon.propTypes = {
  status: PropTypes.oneOf(Object.values(StatusEnum)).isRequired,
  count: PropTypes.number,
  size: PropTypes.number,
  isCountTypeIcon: PropTypes.bool,
  isOutlined: PropTypes.bool,
};

export default StatusIcon;
